/**
 * Created by Christof Sander on 28.09.2016.
 */

module.exports = {

	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();
			event.data.component.open()
		}
	},

	methods: {
		open: function(overrideDataJSON){
			const self = this;
			if(self.formMapping && self.formMapping.fieldConfig && self.formMapping.fieldConfig.isFilterField) return;

			if(overrideDataJSON !== undefined){
				self.model.dataJSON = overrideDataJSON
			}

			self.performAndStoreAction(
				'openModalInCharge',
				self.prepareAction(
					'openModal',
					undefined,
					{
						dataJSON: self.model.dataJSON
					},
					{
						source: {
							load: {
								componentData: {
									model: {
										title: 'JSON - Editor',
										buttons: [
											{ buttonType: 'submit', text: 'Übernehmen' },
											{ buttonType: 'cancel', text: 'Abbrechen' }
										]
									},
									actions: {
										loadContent: {
											source: {
												load: {
													resourceRegisterKey: 'dataJSON',
													componentData: {
														component: [
															'/',
															'base',
															'form',
															'fields',
															'json-editor'
														]
													}
												}
											}
										}
									}
								}
							}
						}
					}
				)
			);
		}
	},

	hooks: {
		onDecision: function($element, options){
			if((((this.actions.openModalInCharge || {}).source || {}).load || {}).component){
				switch(options.decisionType){
					case 'submit':
						var self = this;
						this.actions.openModalInCharge.source.load.component.find('base_form_fields_json-editor', function(jsonEditorComponent){
							self.model.dataJSON = jsonEditorComponent.getEditorContent();
						});

						this.actions.openModalInCharge.source.load.component.hide();
						this.parent(function(parentComponent){
							parentComponent.trigger('onChildChanged', {
								fieldCode:  self.model.fieldCode,
								value:      this.model.dataJSON
							});
						});
						break;

					case 'cancel':
						// do nothing
						this.actions.openModalInCharge.source.load.component.hide();
						break;

					default:
						this.actions.openModalInCharge.source.load.component.hide();
				}

			}
		}
	}
};
